// @ts-nocheck
import styled, { css } from "styled-components";

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { WishListModel } from "@insite/client-framework/Types/ApiModels";
import EditIcon from "@insite/mobius/Icons/Edit2";
import AddIcon from "@insite/mobius/Icons/PlusSquare";
import { Icon, Typography } from "@insite/mobius/index";

import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import PenSquare from "@store/Library/Components/Icons/PenSquare";
import colors from "@store/Themes/common/styleguide/config/colors";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { useState } from "react";

interface EditProductsBuyingsListButtonProps {
    onClick: () => void;
    items: number;
}
interface EditProductBuyingsListButtonStyles {
    buttonRow: InjectableCss;
}
export const editProductsBuyingsListButtonStyles: EditProductBuyingsListButtonStyles = {
    buttonRow: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.25rem;
            cursor: pointer;
            width: fit-content;
        `,
    },
};
export const ButtonRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${pxToRem(6)};
    cursor: pointer;
    width: fit-content;
`;
const EditProductsBuyingsListButton: React.FC<EditProductsBuyingsListButtonProps> = ({ onClick, items }) => {
    const [isHovering, setIsHovering] = useState(false);
    const hasItems = items > 0;
    return (
        <>
            <ButtonRow
                data-test-selector="buyingListManagement_editProductsButton"
                onClick={onClick}
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
            >
                <Typography
                    css={css`
                        font-size: ${pxToRem(20)};
                        font-weight: 600;
                        color: ${isHovering ? getColor("secondary") : getColor("primary")};
                    `}
                >
                    {items}
                </Typography>
                <Icon
                    color={isHovering ? colors?.secondary?.main : colors?.primary?.main}
                    size={24}
                    src={hasItems ? PenSquare : AddIcon}
                />
            </ButtonRow>
        </>
    );
};

export default EditProductsBuyingsListButton;
